/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".error-message[_ngcontent-%COMP%]{transition:opacity 60ms ease-in;transition-delay:70ms;font-size:15px;font-weight:600;margin-top:4px;min-height:20px;color:#d54230}.message-text[_ngcontent-%COMP%]{padding-left:4px}"];
export { styles as styles };
